import { Routes } from 'constants/global'
import { ROLES } from 'prace-common-components'

export function getDefaultRoute(role?: ROLES) {
  if(role === ROLES.USER) return Routes.HOME
  else return Routes.APPLICATIONS
}
